import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { LcsSingleSelectSelectedEvent } from 'src/app/common-components/entity-select/single-select/single-select-base';
import { DepartmentOption } from '../department-register/models/department-option-interface';
import { MergeDepartmentFormData } from '../department-register/models/merge-department-form-data';
import { MergeDepartmentForm } from './models/merge-department.form';

@Component({
    selector: 'ndt-merge-department',
    templateUrl: './merge-department.component.html',
    standalone: false
})
export class MergeDepartmentComponent implements OnInit {
   form: UntypedFormGroup;

   sourceDepartmentName: string | null;

   sourceDepartments: DepartmentOption[] | null;

   accountId: number | null;

   constructor(
      @Inject(MAT_DIALOG_DATA) public data: MergeDepartmentFormData,
      private dialogRef: MatDialogRef<MergeDepartmentComponent>,
      private fb: UntypedFormBuilder,
      private store: Store
   ) {
      this.sourceDepartmentName = data.sourceDepartmentName;
      this.sourceDepartments = [{ departmentId: data.sourceDepartmentId ?? 0, name: data.sourceDepartmentName }];
   }

   ngOnInit(): void {
      const form: MergeDepartmentForm = {
         sourceDepartmentId: this.fb.control(this.data.sourceDepartmentId ?? null, [Validators.required]),
         destinationDepartment: this.fb.control(null, [Validators.required]),
         destinationDepartmentId: this.fb.control(null, [Validators.required]),
      };
      this.form = this.fb.group(form);
      this.accountId = this.data.accountId;
   }

   onSubmit(): void {
      if (this.form.valid) {
         const departmentToSave: MergeDepartmentForm = this.form.value;
         this.dialogRef.close(departmentToSave);
      }
   }

   onCloseClick(): void {
      this.dialogRef.close(null);
   }

   selected(event: LcsSingleSelectSelectedEvent<DepartmentOption>): void {
      if (event.option.value) {
         this.form.get('destinationDepartmentId')?.setValue(event.option.value.departmentId);
      } else {
         this.form.get('destinationDepartmentId')?.setValue(null);
      }
   }
}
